import React , {Fragment} from "react";
import { Formik } from "formik";
import cx from 'classnames';
import {
    Card,
    CardBody,
    CardHeader,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    FormText,
    InputGroup,
    ModalHeader,
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import {
    getServerDomainURL,
    getWhatsAppSettings,
    handleErrorResponse,
    showToast,
    syncTemplates,
    updateWpConnectionError,
    updateWpConnectionMode,
    getWAAnalyticsDetails,
    updateWhatsAppCredentials,
    getTokenFromHash,
    decodeString
} from "../../Common/Appcommon";
import whatsappApi from "../../services/whatsappApi.service";
import requestApi from "../../services/requestApi.service";
import ListTable from "../../Common/ListTable";
import CratioTooltip from "../../Common/CratioTooltip";
import Switch from "react-switch";
import Loading from "../../Common/Loading";


class CloudApiSettings extends React.Component {
    APP_ID = process.env.WHATSAPP_APP_ID; // Replace with your Meta App ID
    CONFIG_ID = process.env.WHATSAPP_ES_CONFIG_ID; // Replace with WhatsApp Embedded Signup config ID

    constructor(props) {
        super(props);
        let baseUrl = getServerDomainURL();
        this.state = {
            connectionErr : '',
            phoneNumbersInfo : [],
            accountId : '',
            accessToken : '',
            defaultNumber : '',
            phoneNumberId : '',
            prevCredUpdated : false,
            connected : false,
            users : [],
            userId : '',
            settings : {},
            copied : false,
            webhookUrl : baseUrl+"/Customize/whatsapp/webhook.php",
            status : '',
            tier : '',
            score : '',
            balcount : '',
            usedCount : '',
            Unsubscribe : true,
            enableReinitialize : false,
            showLoader : false,
            initiateRegister : false,
            phoneDetails: {},
            otpValue: "",
            showRegLoading: false,
            userIdChanged: false,
        }
    }

    async componentDidMount() {
        this.setState({
            showLoader : true
        })
        await this.getWhatsAppSettings();
        await this.getWhatsAppPhoneNumbers();
        if(window.location.hash !== null){
            const token = await getTokenFromHash(window.location.hash, "token");
            if(token !== "" && token !== undefined && token !== null){
                await this.loadWABusiness(token)
            
            }
        }
        this.setState({
            showLoader : false
        })
    }

    getWhatsAppSettings = async ()=> {

        let { accountId, accessToken, defaultNumber,phoneNumberId,userId,status,tier,score,balcount,usedCount } = this.state;
        let whatsappResponse = await getWhatsAppSettings();
        let wasettings = whatsappResponse[0];
        let users = whatsappResponse[1];
        let settings = {};
        let wacampaigncountlimit = await getWAAnalyticsDetails();
            status = '';
            tier = '';
            score = '';
            if(wacampaigncountlimit.length > 0 && wacampaigncountlimit[0].length > 0){
                status = wacampaigncountlimit[0][0];
                tier = wacampaigncountlimit[0][1];
                score = wacampaigncountlimit[0][2];
            }
            // usedCount = wacampaigncountlimit[1][0];
           // if(usedCount == ''){
               // usedCount = 0;
          //  }
            //balcount = tier - usedCount;
        if(wasettings.length > 0){
            settings = wasettings[0];
            accountId = settings.account_id;
            accessToken = settings.access_token;
            defaultNumber = settings.business_number;
            phoneNumberId = settings.phone_number_id;
            userId = settings.userId;
        }
        if(userId == "" && users.length > 0){
            userId = users[0]['id'];
        }
        this.setState({ accountId, accessToken, defaultNumber, users,settings,phoneNumberId, userId,status,tier,score,balcount,usedCount, prevCredUpdated : true });
    }

    autoUnsubscribe = (e) => {
        this.setState({ Unsubscribe: e });
    }


    getWhatsAppPhoneNumbers = async ()=>{
        let res = await whatsappApi.getLinkedPhoneNumbers();
        if(res.status === 'success'){
            this.setState({ phoneNumbersInfo : res.data, connected : true })
        }
    }

    validate = (values) => {
        let errors = {};

        let { connected } = this.state;

        if(values.accountId === '' && !connected){
            errors.accountId = "Bussiness Account Id is required.";
        }

        if(values.accessToken === '' && !connected){
            errors.accessToken = "Access Token is required.";
        }
        return errors;
    };

    submitForm = async (values,actions) => {

        let {connected, defaultNumber, phoneNumberId, users} = this.state;
        let phoneNumbersInfo = [];
        let connectionErr = '';

        if (!connected) {
            let res = await whatsappApi.getLinkedPhoneNumbers(values.accountId, values.accessToken, true);
            if (res.status === 'success') {
                phoneNumbersInfo = res.data;

                //update first mobile number as default mobile number.
                if(defaultNumber === '' && phoneNumberId === ''){
                    if(phoneNumbersInfo !== undefined && phoneNumbersInfo.length > 0){
                        if(phoneNumbersInfo[0].id !== undefined && phoneNumbersInfo[0].display_phone_number !== undefined){
                            defaultNumber = phoneNumbersInfo[0].display_phone_number;
                            phoneNumberId = phoneNumbersInfo[0].id;
                        }
                    }
                }

                //update default user if userId is empty
                if(values.userId === '' || values.userId == null){
                    if(users.length > 0 && users[0]['id'] !== undefined){
                        values.userId = users[0]['id'];
                    }
                }

                let wpStatus = await updateWhatsAppCredentials(values.accountId, values.accessToken, defaultNumber, phoneNumberId, values.userId);
                if(wpStatus){
                    let {accountId, accessToken} = values;
                    this.setState({accountId,accessToken, enableReinitialize : true});
                }
        
                connected = true;
            } else {
                connectionErr = res.message !== undefined ? res.message : '';
            }
        } else {
            await updateWhatsAppCredentials();
            connected = false;
            defaultNumber = '';
            phoneNumberId = '';
            if(actions !== undefined){
                actions.resetForm({
                    values: {accountId: "", accessToken: ""},
                });
            } else {
                this.setState({accountId : "", accessToken : "", enableReinitialize : true})
            }
        }
        this.setState({phoneNumbersInfo, connectionErr, connected, defaultNumber, phoneNumberId});
    }

    /*updateWhatsAppCredentials = async (accountId='',accessToken='',defaultNumber='',phoneNumberId='', userId) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_WHATSAPP_SETTINGS",
            "SETTINGS": {
                "account_id": accountId,
                "access_token": accessToken,
                "business_number" : defaultNumber,
                "phone_number_id" : phoneNumberId,
                "userId" : userId,
                "provider" : 'WHATSAPP_CLOUD_API',
                "baseurl" : `${process.env["REACT_APP_CLOUD_API_URL"]}/${process.env["REACT_APP_CLOUD_API_VERSION"]}/`
            }
        };

        let response = await requestApi.processServerRequest(params,'web','post');
        if(response.issuccess){
            let whatsappResponse = await getWhatsAppSettings(true);
            this.setState({accountId,accessToken});
            if(accountId !== ''){
                updateWpConnectionMode('cloudapi');
                updateWpConnectionError('false');
                showToast('WhatsApp Cloud API connected.');
                await syncTemplates();
            }else{
                updateWpConnectionError('true');
                showToast('WhatsApp Cloud API disconnected.');
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }*/

    setDefaultPhoneNumber = async ({defaultNumber,phoneNumberId}) => {

        let { accountId, accessToken, userId } = this.state;
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_WHATSAPP_SETTINGS",
            "SETTINGS": {
                "account_id": accountId,
                "access_token": accessToken,
                "business_number" : defaultNumber,
                "phone_number_id" : phoneNumberId,
                "provider" : 'WHATSAPP_CLOUD_API',
                "userId" : userId,
                "baseurl" : `${process.env["REACT_APP_CLOUD_API_URL"]}/${process.env["REACT_APP_CLOUD_API_VERSION"]}/`
            }
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            await getWhatsAppSettings(true);
            this.setState({ defaultNumber, phoneNumberId });
            showToast('Default Number updated.');
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    registerPhoneNumber = async () => {   
        let { accountId, accessToken, userId, phoneDetails, otpValue } = this.state;
        let {phoneNumberId} = phoneDetails;
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "REGISTER_PHONENUMBER",
            "WADETAIL": {
                "account_id": accountId,
                "access_token": accessToken,
                "phone_number_id" : phoneNumberId,
                "OTP": otpValue,
                "provider" : 'WHATSAPP_CLOUD_API',
                "userId" : userId,
                "baseurl" : `${process.env["REACT_APP_CLOUD_API_URL"]}/${process.env["REACT_APP_CLOUD_API_VERSION"]}/`
            }
        };
        this.setState({
            showRegLoading: true
        })
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
        if (response.data !== '' && response.data !== null) {
            if(response.data['error'] && response.data['error'] !== '' && response.data['error'] !== undefined){
                let result = response.data['error'];
                if (result !== '' && result !== null){
                    handleErrorResponse(result);
                }
            }   
        }if(response.data){
            if(response.data["success"]){
                const issuccess = response.data["success"];
                if(issuccess){
                    showToast('Successfully Registered');
                    this.setState({
                        initiateRegister: false,
                        phoneDetails: {},
                        otpValue: "", 
                        showLoader : true,
                        showRegLoading: false
                    })
                    await this.getWhatsAppPhoneNumbers();
                    this.setState({
                        showLoader : false,
                    })
                }
            }
        }
        }
 }


    handleEvents = async (name,e) => {
        if(name === 'set_default_number'){
            await this.setDefaultPhoneNumber(e);
        }else if(name === 'register_PH_No'){
            //await this.registerPhoneNumber(e);
            this.toggleNumberRegistration();
        }
    }

    toggleNumberRegistration = (phoneDetails = {}) => {
        let initiateRegister = this.state.initiateRegister;
        if(!initiateRegister){
            this.setState({
                initiateRegister: true,
                phoneDetails: phoneDetails
            });
        } else {
            this.setState({
                initiateRegister: false,
                phoneDetails: {},
            });
        }        
    }

    //Here stats and props belongs to List Table.
    renderElements =  (name,formData,fields,childprops,childstate) => {

        let { defaultNumber,Unsubscribe } = this.state;
        let status = formData['status'];

        if(name === 'defaultButton'){
            return (
                <>
                <span className="mb-3">{formData['verification_status'] === "NOT_VERIFIED" ? "NOT VERIFIED" : status}</span><br />
                {
                    status === "PENDING" && (
                        <Button
                            className={cx(`le-btn-sm mb-2 lePrimaryBtn`, {"hide": status === "CONNECTED"})}
                            onClick={() => {this.toggleNumberRegistration({defaultNumber: formData['phone_number'],phoneNumberId: formData['id']});}}
                        >
                            Register 
                        </Button>
                    )
                }
                <br />
                <Button
                    className={ cx(`le-btn-sm lePrimaryBtn`,{
                        "disabled" : /*formData['status'] !== 'VERIFIED' || */defaultNumber === formData['phone_number']
                    })}
                    disabled={ (!(/*formData['status'] === 'VERIFIED' && */defaultNumber !== formData['phone_number'])) || formData['verification_status'] === "NOT_VERIFIED"}
                    onClick={()=>{childprops.handleEvents('set_default_number',{defaultNumber : formData['phone_number'], phoneNumberId : formData['id'] })}}
                >
                    Set as Default
                </Button>
                </>
            );
        }else if(name === 'defaultLabel'){
            if(defaultNumber === formData['phone_number']){
                return (
                    <>
                        {formData['id']}
                        <div className=" ml-1 badge rounded-pill bg-success">
                            Default
                        </div>
                    </>

                );
            }else{
                return <>{formData['id']}</>
            }
        }

    }

    webhookUrlCopy = () => {
        this.setState({ copied: true });
    }

    connectWhatsAppEmbed = async (e) => {
        let {connected} = this.state;
        if(connected){
	    await this.submitForm();
            return;
        }
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : "GET_ES_OAUTH",
        };
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            let url = response.data;
            window.location = url;
        }
    }

    loadWABusiness = async (token) => {
        let data = decodeString(token, true);
        if(data.issuccess){
            let {accessToken, business_info} = data;
            let businessId = "";
            let businessName = "";
            if(business_info['data'] !== undefined){
                let waData = business_info['data'];
                if(waData.length > 0){
                    businessId = waData[0]['id'];
                    businessName = waData[0]['name'];
                    let values = {accountId: businessId, accessToken: accessToken};
                    this.setState({accountId : businessId, accessToken : accessToken})
                    await this.submitForm(values);
                    const urlWithoutHash = window.location.href.split('?')[0];
                    window.location = urlWithoutHash;
                }
            }
        } else {
            console.log(data);
            showToast("Something went wrong. Please try again later.");
        }
    }

    saveAssignedUser = async (selectedUserId) => {
        let { accountId, accessToken, defaultNumber, phoneNumberId } = this.state;
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_WHATSAPP_SETTINGS",
            "SETTINGS": {
                "account_id": accountId,
                "access_token": accessToken,
                "business_number" : defaultNumber,
                "phone_number_id" : phoneNumberId,
                "provider" : 'WHATSAPP_CLOUD_API',
                "userId" : selectedUserId,
                "baseurl" : `${process.env["REACT_APP_CLOUD_API_URL"]}/${process.env["REACT_APP_CLOUD_API_VERSION"]}/`
            }
        };
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            await getWhatsAppSettings(true);
            this.setState({ userId: selectedUserId, userIdChanged: false });
            showToast('Assigned user updated.');
        } else {
            handleErrorResponse(response.errormsg);
        }
    }

    onOTPChange = (e) => {
        let value = e.target.value;
        this.setState({
            otpValue: value
        })
    }
    

    render(){
        let { accountId, showLoader, showRegLoading, otpValue, accessToken, connectionErr, prevCredUpdated, phoneNumbersInfo, connected, users,settings, copied, webhookUrl,userId,status,tier,score,balcount,usedCount,Unsubscribe,enableReinitialize,initiateRegister,userIdChanged } = this.state;
        const initialValues = {
            accountId: accountId,
            accessToken: accessToken,
            userId : userId
        };
        let Score = score;
        let Tier = tier;
        let Status = status;
        let Balcount = balcount;
        // console.log(Score)
        let formData = [];
        //let listFields = [['id','Phone number ID'],['name','Name'],['phone_number','Phone Number'],['rating','Rating'],['status','Status'],['action','Action']];
        let listFields = [['Display Name','Phone Number / ID','MSG LIMIT','Status'],['name','phone_number','msglimit','action']];
        // let listFields1 = [['Messaging Limit','Quality Rating','Phone Number Status','Action'],['msglimit','rating','status','action']]
        for(let i in phoneNumbersInfo){
            formData[i] = [];
            /*formData[i]['Phone number ID'] = phoneNumbersInfo[i].id;
            formData[i]['Name'] = phoneNumbersInfo[i].verified_name;
            formData[i]['Phone Number'] = phoneNumbersInfo[i].display_phone_number;
            formData[i]['Rating'] = phoneNumbersInfo[i].quality_rating;
            formData[i]['Status'] = phoneNumbersInfo[i].code_verification_status;*/
            formData[i]['id'] = phoneNumbersInfo[i].id;
            formData[i]['name'] = phoneNumbersInfo[i].verified_name + " <span style='color:" + (phoneNumbersInfo[i].quality_rating === "GREEN" ? "green" : "orange") + "'>" + (phoneNumbersInfo[i].quality_rating === "GREEN" ? "HIGH" : "MEDIUM") + "</span>";
            formData[i]['phone_number'] = phoneNumbersInfo[i].display_phone_number + "<br> ID : " + phoneNumbersInfo[i].id;
            // formData[i]['rating'] = phoneNumbersInfo[i].quality_rating === "GREEN" ? "HIGH" : "MEDIUM";
            formData[i]['status'] = phoneNumbersInfo[i].status;
            formData[i]['msglimit'] = (tier >= 1000) ? (tier / 1000) + 'K/24hr' : "";
            formData[i]['verification_status'] = phoneNumbersInfo[i].code_verification_status;
        }
        let customFieldConfig = {
            action:{
                "render" : "defaultButton"
            },
            id : {
                "render" : "defaultLabel"
            }
        };
        let that = this;
        return (
            <Loading showLoader={showLoader} mainContent={
                <Fragment>
                    <div className="listview-container kv-main-wrapper h100per w-100 ">
                        <div className={`col-xl-12 col-lg-12 col-md-12 m-auto pl-0 pr-0 pl-sm-3 pr-sm-3 mt-2`}>
                            <Container fluid>
                                <Card className="main-card border mb-3">
                                    <CardHeader className={`le-card-header`}>
                                        WHATSAPP CLOUD API SETTINGS
                                        <div className={`btn-actions-pane-right  d-flex mr-4 w-2`}>
                                            <div>
                                                <a onClick={(e) => {this.connectWhatsAppEmbed(e)}} className={`header-notification-url  analyticsbussinessbtn le-button lePrimaryBtn le-api-btn btn btn-success me-2 w-2`}>{connected ? `Disconnect WhatsApp` : `Connect WhatsApp`}</a>
                                            </div>
                                            <div>
                                            <a target='_blank' href={`https://business.facebook.com/wa/manage/home/`} className={`header-notification-url hide analyticsbussinessbtn le-button lePrimaryBtn le-api-btn btn btn-success me-2 w-2`}>{`WHATSAPP MANAGER`}</a>
                                            </div>
                                            <div>
                                                <a target='_blank' href={`https://business.facebook.com/settings/whatsapp-business-accounts/`} className={`header-notification-url hide analyticsbussinessbtn le-button lePrimaryBtn le-api-btn btn btn-success  `}>{`WHATSAPP PAYMENT SETTINGS`}</a>

                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        {connectionErr !== '' && (
                                            <div className={`alert alert-danger mb-3`}>
                                                {connectionErr}
                                            </div>
                                        )}
                                        {
                                            prevCredUpdated &&
                                            (<Formik
                                                initialValues={initialValues}
                                                validate={this.validate}
                                                onSubmit={this.submitForm}
                                                enableReinitialize={enableReinitialize}
                                            >
                                                {function (formik) {
                                                    const {
                                                        values,
                                                        handleChange,
                                                        handleSubmit,
                                                        errors,
                                                        touched,
                                                        handleBlur,
                                                        isValid,
                                                        dirty
                                                    } = formik;

                                                    return (
                                                        <Form onSubmit={handleSubmit}>
                                                            <FormGroup className={'hide'}>
                                                                <Label for="webhookUrl">Webhook URL</Label>
                                                                <InputGroup>
                                                                    <Input value={webhookUrl} disabled={true} />
                                                                    <CopyToClipboard onCopy={(e) => {that.webhookUrlCopy()}} text={webhookUrl}>
                                                                        <Button color="success">
                                                                            <FontAwesomeIcon icon={faCopy} />
                                                                        </Button>
                                                                    </CopyToClipboard>
                                                                </InputGroup>
                                                                {copied ? (
                                                                    <FormText color="success">Text has been copied.</FormText>
                                                                ) : null}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label className={`ft-max-width`} for="accountId">Whatsapp Bussiness Account Id</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="accountId"
                                                                    id="accountId"
                                                                    autoComplete={'off'}
                                                                    value={ values.accountId }
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    disabled={true}
                                                                    invalid={
                                                                        errors.accountId && touched.accountId ?
                                                                            true : false}
                                                                />
                                                                {errors.accountId && touched.accountId && (
                                                                    <FormFeedback>{errors.accountId}</FormFeedback>
                                                                )}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label for="accessToken">Access Token</Label>
                                                                <Input
                                                                    type="password"
                                                                    name="accessToken"
                                                                    id="accessToken"
                                                                    value={values.accessToken}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    disabled={true}
                                                                    invalid={
                                                                        errors.accessToken && touched.accessToken ?
                                                                            true : false}
                                                                />
                                                                {errors.accessToken && touched.accessToken && (
                                                                    <FormFeedback>{errors.accessToken}</FormFeedback>
                                                                )}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label className={'d-flex-alone'} for="userId">Assign New Lead Conversation to <CratioTooltip id={"432"} title={"All new lead conversation will be assigned to this user."} content={<FontAwesomeIcon className={'info-icon'} icon={faCircleInfo}/>} /></Label>
                                                                <div className="d-flex align-items-center">
                                                                    <select
                                                                        name="userId"
                                                                        value={values.userId}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            that.setState({ userIdChanged: e.target.value !== userId });
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        style={{ display: "block" }}
                                                                        className={'form-control'}
                                                                    >
                                                                        {
                                                                            users.map((user, index) => {
                                                                                return (
                                                                                    <option selected={user['id'] == values.userId} value={user['id']}>{user['Name']}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    {userIdChanged && (
                                                                        <Button
                                                                            className="ms-2 le-button lePrimaryBtn"
                                                                            onClick={() => { that.saveAssignedUser(values.userId); }}
                                                                        >
                                                                            Save
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                                {errors.defaultAssignee && <div className="input-feedback">{errors.defaultAssignee}</div>}

                                                            </FormGroup>
                                                            
                                                            <div className={Status == '' && Score == '' && Tier == '' ? "hide":"hide"}><div className={"setting_campcount_details"}>STATUS: <span className={Status =="CONNECTED" ? "setting_campcount_color1" : "setting_campcount_color1_danger"}> {Status}</span></div><div className={"setting_campcount_details"}>TOTAL TIER LIMIT: <span className={"setting_campcount_color2"}> {Tier}</span></div><div className={"setting_campcount_details"}>SCORE: <span className={Score =="GREEN" ? "setting_campcount_color1" : "setting_campcount_color1_danger"}> {Score}</span></div></div>
                                                            <div className="unsubscribe-container">
                                                                <Switch
                                                                    className="unsubswitch"
                                                                    height={20}
                                                                    width={40}
                                                                    onColor={"#23ae73"}
                                                                    checked={Unsubscribe}
                                                                    onChange={(e) => that.autoUnsubscribe(e)}
                                                                />
                                                                <span className="unsubscribe">Auto unsubscribe contact if message sending fails.</span>
                                                            </div>
                                                            <div className={`text-center hide`}>
                                                                <Button type="submit"
                                                                        className={cx("mt-2 le-button lePrimaryBtn le-api-btn",{"disabled-btn" : !isValid })}
                                                                        disabled={!isValid}>
                                                                    { connected ? `Disconnect` : `Connect`}
                                                                </Button>
                                                            </div>
                                                        </Form>
                                                    );
                                                }}
                                            </Formik>)
                                        }
                                    </CardBody>
                                </Card>
                            </Container>
                        </div>
                        <div className={`col-xl-12 col-lg-12 col-md-12 m-auto pl-0 pr-0 pl-sm-3 pr-sm-3 mt-2  mb-6`}>
                            <Container fluid>
                                <Card className="main-card border mb-3">
                                    <CardHeader className={`le-card-header`}>Phone Numbers</CardHeader>
                                    <CardBody>
                                        <ListTable
                                            key={Math.random()}
                                            aliasIndex={'0'}
                                            labelIndex={'1'}
                                            formData={formData}
                                            fields={listFields}
                                            config={customFieldConfig}
                                            showRowCount={false}
                                            spaceBfCell={false}
                                            noDataMsg={`Phone numbers not found`}
                                            renderElements={this.renderElements}
                                            handleEvents={this.handleEvents}
                                        />
                                    </CardBody>
                                </Card>
                            </Container>
                            {initiateRegister && 
                                <Modal isOpen={initiateRegister} >
                                    <ModalHeader toggle={this.toggleNumberRegistration}>
                                        <span>Register Phone Number</span>
                                    </ModalHeader>
                                    <ModalBody>
                                        <label>OTP: </label>
                                        <input
                                            type="text"
                                            maxLength="6"
                                            value={otpValue}
                                            onChange={(e) => this.onOTPChange(e)}
                                            placeholder="Enter 6-digit OTP"
                                            className="form-control"
                                        />
                                        <span className="note-text">Enter the OTP sent by Facebook during phone number registration or embedded signup in WhatsApp Manager.</span>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Loading showLoader={showRegLoading} mainContent={
                                        <Button className="btn-wide mb-2 me-2" color="success" onClick={(e) => {this.registerPhoneNumber(e)}}>
                                            Register
                                        </Button>
                                        } />
                                    </ModalFooter>
                                </Modal>
                            }
                        </div>
                    </div>
                </Fragment>
            } />
        )
    }
}

export default CloudApiSettings;
